module.exports = __webpack_public_path__ + "static/media/VGMeter.9651bdfc.svg";